import { getEnvVars } from '@environment';

const { appName } = getEnvVars();

export abstract class UnistocksSettings {
  public static readonly Prefix = 'UnifyStocks';
  public static readonly AppPrefix = this.Prefix + `.${appName}`;

  public static readonly ThemeGroup = this.AppPrefix + '.Theme';
  /**
   * The preferred theme of the user.
   * null: Auto, use device settings
   */
  public static readonly PreferredTheme = this.ThemeGroup + '.Preferred';

  public static readonly ProfileGroup = this.AppPrefix + '.Profile';
  // Language is global, for all apps
  public static readonly Language = this.Prefix + '.Profile.Language';

  public static readonly OnboardingComplete = this.Prefix + '.OnboardingComplete';

  public static readonly InvestmentGroup = this.Prefix + '.Investments';
  public static readonly TransactionBreakpoint = this.InvestmentGroup + '.TransactionBreakpoint';

  public static readonly DashboardPrefix = this.Prefix + '.Dashboard';
  public static readonly DashboardLayout = this.DashboardPrefix + '.Layout';
}

export abstract class AbpSettings {
  public static readonly Prefix = 'Abp';

  public static readonly IdentityGroup = this.Prefix + '.Identity';
  public static readonly Password = this.IdentityGroup + '.Password';

  public static readonly SignInGroup = this.IdentityGroup + '.SignIn';
  public static readonly RequireConfirmedEmail = this.SignInGroup + '.RequireConfirmedEmail';

  public static readonly TimeZone = this.Prefix + '.Timing.TimeZone';
}
